export default __webpack_public_path__ + "static/ExpressJS-25bcb2a30cc1016cde2f772f3998bc73.svg";